//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


    import Group from 'vux/src/components/group/index.vue';
    import XInput from 'vux/src/components/x-input/index.vue';
    import XSwitch from 'vux/src/components/x-switch/index.vue';
    import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
    import utils from '../utils/index';
    import * as CONSTANTS from '../constants/index';
    import { types } from 'util';

    export default {
        name:'OwnerSame',
        data(){
            return{
                title:'',
                titleMsg:'',
                sameFlag:true,
                type:Number,
                tips:'',
                flag1:true,
                flag2:true,
                appPhone:'',
                insPhone:'',
                carBeans:utils.deepClone(CONSTANTS.CAR_BEANS),
            }
        },
        mounted(){
            this.carBeans=this.quoteInfo;
//            this.type = '4';
            this.type = this.$route.params.type;
            this.title='手机号实名信息验证';
            switch(this.type){
                case '1':
                    this.appPhone = this.carBeans.applicant.phone;
                    break;
                case '2':
                    this.insPhone = this.carBeans.insured.phone;
                    break;
                case '4':
                    this.appPhone = this.carBeans.applicant.phone;
                    this.insPhone = this.carBeans.insured.phone;
                    break;
            }
        },
        created(){

        },
        components: {
            XSwitch,Group,XInput
        },
        computed:{
            ...mapState({
                quoteInfo: state => state.quote.quoteInfo,
                switchList: state => state.quote.switchList,
            }),
        },
        methods:{
            ...mapMutations({
                setInsuredTips:'setInsuredTips',
                setApplicantTips:'setApplicantTips',
                setHolderMsg:'setHolderMsg',
            }),
            onSelect(card){
                let e=window.event;
                if (e.target.files.length < 1) {
                    return;
                }
                let file = e.target.files[0],
                    type = file.type; //"image/png"
                let reader = new FileReader();
                reader.readAsDataURL(file);
                let _this = this;
                reader.onload = function(e) {
                    let res = e.target.result;
                    if (type.indexOf('image') > -1) {
                        _this.zipImgUpload(file, res, card); //压缩上传
                    } else {
                        Toast('请选择图片上传');
                    }
                };

            },
            modify(a){
                switch(this.type){
                    case '1':
                        this.flag1 = !this.flag1;
                        if(this.flag1){
                            this.carBeans.applicant.phone=this.appPhone;
                        }
                        break;
                    case '2':
                        this.flag2 = !this.flag2;
                        if(this.flag2){
                            this.carBeans.insured.phone=this.insPhone;
                        }
                        break;
                    case '4':
                        if(a == 'a'){
                            this.flag1 = !this.flag1;
                            if(this.flag1){
                                this.carBeans.applicant.phone=this.appPhone;
                            }
                        }else if(a == 'b'){
                            this.flag2 = !this.flag2;
                            if(this.flag2){
                                this.carBeans.insured.phone=this.insPhone;
                            }
                        }
                        break;
                }
            },
            zipImgUpload(file, res,card) {
                //压缩上传图片 imagePath
                let Upload = new SnkUpload(),
                    _this = this;
                Upload.compress({
                    url:'/Interface_Cluster/HttpUploadAction',
                    chunckCount: 1, //暂不分片，待后端支持
                    quality: 0.3,
                    file,
                    getCompressedFileInfo(info) {
                        // 可以获取到md5
                        // 可以判断 文件大小 然后动态设置 info.instance.chunckCount = n;
                        // info.instance.chunckCount = 1;
                        // console.log(info);
                        // params.File = info.base64Str;
                        _this.uploadFile(info,card);
                    },
                    success(params) {},
                    error(params) {
                        // console.log(params);
                        Toast('证件上传失败，请重新上传');
                    }
                });
            },
            uploadFile(info,card) {
                let _this = this;
                let base64=info.base64Str.split('base64,')[1];
                const newOcrSwitch = this.switchList.newOcrSwitch === '1'
                const { getOcrUrlName, getOcrKey } = utils
                $http[getOcrUrlName(newOcrSwitch, '2')]({
                    data:{
                        type:'2',
                        imgData:base64
                    }
                }).then(res => {
                    // console.log(card);
                    if(res.resultCode=='0'){
                        if(card==1){//被保人身份证
                            _this.carBeans.insured.name=res.result.name ? res.result.name : '';
                            _this.carBeans.insured.identifyNumber=res.result[getOcrKey(newOcrSwitch, 'identifyNumber')] ? res.result[getOcrKey(newOcrSwitch, 'identifyNumber')] : '';
                        }else{//投保人身份证
                            _this.carBeans.applicant.name=res.result.name ? res.result.name : '';
                            _this.carBeans.applicant.identifyNumber=res.result[getOcrKey(newOcrSwitch, 'identifyNumber')] ? res.result[getOcrKey(newOcrSwitch, 'identifyNumber')] : '';
                        }
                    }else{
                        Toast(res.errorMsg);
                    }

                })
            },
            handleSubmit(){
                if(this.type==1){
                    if(!this.carBeans.applicant.phone){
                        Toast('请输入投保人联系电话');
                        return
                    }else if(!/^([1][3-9][0-9]{9})$|^((\d){3}(\*){4}(\d){4})$/.test(this.carBeans.applicant.phone)){
                        Toast('投保人联系电话输入有误');
                        return
                    }
                    if(!this.carBeans.applicant.phoneHolder && this.flag1){
                        Toast('请输入持有人姓名');
                        return
                    }
                    if(!this.carBeans.applicant.holderCertiCode && this.flag1){
                        Toast('请输入持有人身份证号');
                        return
                    }else if(!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(this.carBeans.applicant.holderCertiCode) && this.flag1){
                        Toast('持有人身份证号格式错误');
                        return
                    }
                    if(!this.flag1){
                        this.carBeans.applicant.phoneHolder = '';
                        this.carBeans.applicant.holderCertiCode = '';
                    }
                    this.carBeans.applicant.holderType = '1';
                    this.carBeans.applicant.holderCertiType = this.carBeans.applicant.identifyType;
                    this.setHolderMsg(this.tips);
                }else if(this.type==2){
                    if(!this.carBeans.insured.phone){
                        Toast('请输入被保人联系电话');
                        return
                    }else if(!/^([1][3-9][0-9]{9})$|^((\d){3}(\*){4}(\d){4})$/.test(this.carBeans.insured.phone)){
                        Toast('被保人联系电话输入有误');
                        return
                    }
                    if(!this.carBeans.insured.phoneHolder && this.flag2){
                        Toast('请输入持有人姓名');
                        return
                    }
                    if(!this.carBeans.insured.holderCertiCode && this.flag2){
                        Toast('请输入持有人身份证号');
                        return
                    }else if(!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(this.carBeans.insured.holderCertiCode) && this.flag2){
                        Toast('持有人身份证号格式错误');
                        return
                    }
                    if(!this.flag2){
                        this.carBeans.insured.phoneHolder = '';
                        this.carBeans.insured.holderCertiCode = '';
                    }
                    this.carBeans.insured.holderCertiType = this.carBeans.insured.identifyType;
                    this.setHolderMsg(this.tips);
                }else if(this.type==4){
                    if(!this.carBeans.applicant.phone){
                        Toast('请输入投保人联系电话');
                        return
                    }else if(!/^([1][3-9][0-9]{9})$|^((\d){3}(\*){4}(\d){4})$/.test(this.carBeans.applicant.phone)){
                        Toast('投保人联系电话输入有误');
                        return
                    }
                    if(!this.carBeans.applicant.phoneHolder && this.flag1){
                        Toast('请输入投保人持有人姓名');
                        return
                    }
                    if(!this.carBeans.applicant.holderCertiCode && this.flag1){
                        Toast('请输入投保人持有人身份证号');
                        return
                    }else if(!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(this.carBeans.applicant.holderCertiCode) && this.flag1){
                        Toast('投保人持有人身份证号格式错误');
                        return
                    }
                    if(!this.carBeans.insured.phone){
                        Toast('请输入被保人联系电话');
                        return
                    }else if(!/^([1][3-9][0-9]{9})$|^((\d){3}(\*){4}(\d){4})$/.test(this.carBeans.insured.phone)){
                        Toast('被保人联系电话输入有误');
                        return
                    }
                    if(!this.carBeans.insured.phoneHolder && this.flag2){
                        Toast('请输入被保人持有人姓名');
                        return
                    }
                    if(!this.carBeans.insured.holderCertiCode && this.flag2){
                        Toast('请输入被保人持有人身份证号');
                        return
                    }else if(!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(this.carBeans.insured.holderCertiCode) && this.flag2){
                        Toast('被保人持有人身份证号格式错误');
                        return
                    }
                    if(!this.flag1){
                        this.carBeans.applicant.phoneHolder = '';
                        this.carBeans.applicant.holderCertiCode = '';
                    }
                    if(!this.flag2){
                        this.carBeans.insured.phoneHolder = '';
                        this.carBeans.insured.holderCertiCode = '';
                    }
                    this.carBeans.applicant.holderType = '1';
                    this.carBeans.applicant.holderCertiType = this.carBeans.applicant.identifyType;
                    this.carBeans.insured.holderCertiType = this.carBeans.insured.identifyType;
                    this.setHolderMsg(this.tips);
                }
                // console.log(this.carBeans);
                this.$router.push({
                    path: '/submit_order',
                    name: 'SubmitOrder',
                });
            },
            goBack(){
                this.$router.push({
                    path: '/submit_order',
                    name: 'SubmitOrder',
                });
            }
        }
    }
